module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Lock-overturning-1d01a9c567831b77f590a623cf8628f8.svg";